type StyledOnlyProp =
  | '$inline'
  | '$isLink'
  | '$hasIcon'
  | '$hasIconAfter'
  | '$hasChildren'
  | '$type'
  | 'dropdownItems'
  | 'dropdownValue'
  | '$primary'
  | '$secondary'
  | '$removeUnderline'
  | '$outline'
  | '$outlineReplacement'
  | '$inverted'
  | '$small'
  | '$smallMobile'
  | '$bold'
  | '$hiddenText'
  | '$hasActiveTick'
  | '$isColumn'
  | '$active'
  | '$stretch'
  | '$wideUnderline'
  | '$jumbo'
  | '$maxHeight'
  | '$thinner'
  | '$icon'
  | '$iconAfter'
  | 'onDropdownChange';

const styledOnlyProps = new Set<string>([
  '$inline',
  '$isLink',
  '$hasIcon',
  '$hasIconAfter',
  '$hasChildren',
  '$type',
  'dropdownItems',
  'dropdownValue',
  '$primary',
  '$secondary',
  '$removeUnderline',
  '$outline',
  '$outlineReplacement', // @todo This should be refactored
  '$inverted',
  '$small',
  '$smallMobile',
  '$bold',
  '$hiddenText',
  '$hasActiveTick',
  '$isColumn',
  '$active',
  '$stretch',
  '$wideUnderline',
  '$jumbo',
  '$maxHeight',
  '$thinner',
  '$icon',
  '$iconAfter',
  'onDropdownChange',
]);

export default function sanitiseProps<TProps extends object>(
  props: TProps = {} as TProps,
): Omit<TProps, StyledOnlyProp> {
  return Object.fromEntries(Object.entries(props).filter(([key]) => !styledOnlyProps.has(key))) as Omit<
    TProps,
    StyledOnlyProp
  >;
}
